<div class="p-3 rounded bg-white shadow" [class.h-100]="h100()">
  <ng-content></ng-content>
</div>
